import React from 'react'
import { ColorSquare } from '@therms/atalaya'
import { IdLabel, RPCDocs } from '@therms/react-modules'

interface Props {
  report: RPCDocs.Reports.GetReport.v1.Report
}

function ReportTitle({ report }: Props) {
  return (
    <div className="flex items-baseline space-x-xs truncate text-lg">
      {!!report.reportType.color && (
        <ColorSquare color={report.reportType.color} />
      )}

      <span className="ellipsis">{report.title}</span>

      <IdLabel
        className="text-base font-bold tracking-wide text-color-subtle"
        idLabel={report.idLabel}
      />
    </div>
  )
}

export { ReportTitle }
